import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../../components/ui/dialog';
import { Printer } from 'lucide-react';
import InvoiceTemplate from '../../../components/Invoice/InvoiceTemplate';

export const InvoiceDialog = ({
  invoiceDialogOpen, setInvoiceDialogOpen, selectedInvoice, invoiceSettings, handlePrintInvoice
}) => (
  <Dialog open={invoiceDialogOpen} onOpenChange={setInvoiceDialogOpen}>
    <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="font-[Manrope]">Invoice - {selectedInvoice?.invoice_number}</DialogTitle>
      </DialogHeader>
      <div className="mt-4">
        <div className="flex justify-end gap-2 mb-4 no-print">
          <Button variant="outline" onClick={() => setInvoiceDialogOpen(false)}>
            Close
          </Button>
          <Button className="bg-red-500 hover:bg-red-600" onClick={handlePrintInvoice} data-testid="print-invoice-btn">
            <Printer className="w-4 h-4 mr-2" />
            Print Invoice
          </Button>
        </div>
        <InvoiceTemplate invoice={selectedInvoice} settings={invoiceSettings} />
      </div>
    </DialogContent>
  </Dialog>
);
